var caretDown = "https://shopfront-cdn.tekoapis.com/static/4c1c0e464c3b7961.svg";

export { caretDown as default };
